<template>
  <div>
    <app-header is-left left-text="地址编辑" @click-left="goBack"></app-header>
    <div class="app-body" ref="body">
      <van-address-edit
        :area-list="areaList"
        show-postal
        show-delete
        show-set-default
        show-search-result
        :area-columns-placeholder="['请选择', '请选择', '请选择']"
        :address-info="obj"
        @save="onSave"
        @delete="onDelete"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import AppHeader from '../app-header';
import tools from '@/utils/tools';
import areas from '@/utils/area';
export default {
  mixins: [tools],
  components: {
    AppHeader
  },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data () {
    return {
      isLoading: false,
      searchResult: [],
    }
  },
  computed: {
    ...mapGetters({
    }),
    areaList() {
      return areas;
    }
  },
  watch: {
    id(val) {
      this.getData();
    }
  },
  created () {
  },
  mounted () {
  },
  activated() {
    if (!this.obj.id || this.id != this.obj.id) {
      this.getData();
    }
  },
  methods: {
    getData() {
      if (!this.id || isLoading) {
        return;
      }
      this.isLoading = true;
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doGet({
        url: 'vue/personal/address/detail/'+ this.id,
        okcb: (json) => {
          this.obj = json;
        },
        cb: () => {
          this.isLoading = false;
          this.Toast.clear();
        }
      })
    },
    goBack() {
      this.$router.go(-1);
    },
    onSave(content) {
      let postData = {};
      Object.keys(content).forEach(k => {
        postData[k.toLowerCase()] = content[k];
      });
      postData.address = postData.addressdetail;
      postData.default = postData.isdefault;

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'vue/personal/address/save',
        data: postData,
        okcb: (json) => {
          postData.id = json.id;
          this.$store.dispatch(types.OTHER.reloadAddress);

          // 如果默认地址
          if (postData.default) {
            this.$store.commit(types.MEMBER_ADDRESS, postData);
          }

          setTimeout(() => {
            this.Toast.success('保存成功！');
          }, 200);
          setTimeout(() => {
            this.goBack();
          }, 800);
        },
        cb: () => {
          this.Toast.clear();
        }
      })
    },
    onDelete() {
      if (this.obj.id) {
        this.Toast.loading({
          message: '删除中...',
          forbidClick: true
        });
        this.doPost({
          url: 'vue/personal/address/del/'+ this.obj.id,
          okcb: (json) => {
            setTimeout(() => {
              this.Toast.success('删除成功!');
              this.goBack();
            }, 500);
            this.$store.dispatch(types.OTHER.reloadAddress);
          },
          cb: () => {
            this.Toast.clear();
          }
        })
      } else {
        Object.assign(this.obj, {});
        this.goBack();
      }
    },
    onChangeDetail(val) {
      if (val) {
        this.searchResult = [{
          name: '黄龙万科中心',
          address: '杭州市西湖区'
        }];
      } else {
        this.searchResult = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '//at.alicdn.com/t/font_919761_cgylur06gh.css';
.app-body {
  margin-top:46px;
  padding-bottom:5rem;
}
</style>